module.exports = __webpack_public_path__ + "img/campaign.svg";